import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';

export interface XimiDeviceContext {
    /** Device id; `null` when the platform provides none (header omitted → Ozmo fallback). */
    uuid: string | null;
    applicationversion: string;
    model: string;
    userAgent: string;
}

let cached: Promise<XimiDeviceContext> | null = null;

/** Contexte device (constant sur la session) — résolu une seule fois puis mémoïsé. */
export function getXimiDeviceContext(): Promise<XimiDeviceContext> {
    if (!cached) cached = resolveXimiDeviceContext();
    return cached;
}

async function resolveXimiDeviceContext(): Promise<XimiDeviceContext> {
    const { identifier } = await Device.getId();
    const info = await Device.getInfo();
    let applicationversion = '';
    try {
        applicationversion = (await App.getInfo()).version;
    } catch {
        // App.getInfo unavailable on web → build version injected by Vite (package.json)
        applicationversion = __APP_VERSION__;
    }
    return {
        // Never a placeholder: every device sending the same value would share one Ozmo session key.
        uuid: identifier || null,
        applicationversion,
        model: `${info.model} ${info.manufacturer}`.trim(),
        userAgent: navigator.userAgent
    };
}
